import React from "react";
import { Box, Card, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import AutoAwesomeMosaicOutlinedIcon from "@mui/icons-material/AutoAwesomeMosaicOutlined";
import BusinessCenterOutlinedIcon from "@mui/icons-material/BusinessCenterOutlined";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { IconTile } from "../../components/ui";
import { CheckList, FeatureCard, PageHero, Section } from "./MarketingParts";

export default function MarketingAbout() {
  const { t } = useTranslation();

  return (
    <>
      <PageHero eyebrow={t("mk_about_eyebrow")} icon={<InfoOutlinedIcon sx={{ fontSize: 16 }} aria-hidden="true" />} title={t("m_about_title")} subtitle={t("m_about_subtitle")} />

      <Section sx={{ pt: { xs: 5, md: 7 } }}>
        <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", md: "1.2fr 1fr" }, gap: { xs: 2.5, md: 3 } }}>
          <FeatureCard>
            <Stack direction="row" spacing={1.5} alignItems="center" sx={{ mb: 2.5 }}>
              <IconTile size={44}>
                <AutoAwesomeMosaicOutlinedIcon />
              </IconTile>
              <Typography variant="h2" sx={{ fontSize: "1.25rem" }}>
                {t("m_about_what_unique_title")}
              </Typography>
            </Stack>
            <CheckList items={[t("m_about_what_unique_1"), t("m_about_what_unique_2"), t("m_about_what_unique_3"), t("m_about_what_unique_4")]} />
          </FeatureCard>

          <FeatureCard>
            <Stack direction="row" spacing={1.5} alignItems="center" sx={{ mb: 2.5 }}>
              <IconTile size={44} tone="teal">
                <BusinessCenterOutlinedIcon />
              </IconTile>
              <Typography variant="h2" sx={{ fontSize: "1.25rem" }}>
                {t("m_about_b2b_title")}
              </Typography>
            </Stack>
            <Typography sx={{ color: "text.secondary", lineHeight: 1.75 }}>{t("m_about_b2b_desc")}</Typography>
          </FeatureCard>
        </Box>

        <Card
          sx={{
            mt: { xs: 2.5, md: 3 },
            p: { xs: 3, md: 4 },
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            gap: 2.5,
            bgcolor: (th) => th.aw.accentSoft,
            borderColor: (th) => th.aw.border,
            boxShadow: "none",
          }}
        >
          <IconTile size={48} variant="solid">
            <VisibilityOutlinedIcon />
          </IconTile>
          <Box>
            <Typography variant="h2" sx={{ fontSize: "1.25rem", mb: 1 }}>
              {t("m_about_transparency_title")}
            </Typography>
            <Typography sx={{ color: "text.secondary", lineHeight: 1.75 }}>{t("m_about_transparency_desc")}</Typography>
          </Box>
        </Card>
      </Section>
    </>
  );
}
